import { useContext } from 'react';

import { K8sProvider } from '@cast/shared-types';

import { AnywhereScriptContent } from './AnywhereScriptContent';
import { RosaScriptContent } from './RosaScriptContent';
import { OnboardClusterContext } from '../../../../../OnboardClusterProvider';

type Props = {
  onHasScriptChanged: (hasScript: boolean) => void;
};

export const GetScriptContent = ({ onHasScriptChanged }: Props) => {
  const { provider } = useContext(OnboardClusterContext);

  switch (provider) {
    case K8sProvider.ROSA:
      return <RosaScriptContent onHasScriptChanged={onHasScriptChanged} />;
    case K8sProvider.ANYWHERE:
      return <AnywhereScriptContent onHasScriptChanged={onHasScriptChanged} />;
    default:
      return null;
  }
};
